module.exports = __webpack_public_path__ + "img/n1.918388ea.jpg";